import {detail} from "@mc/mc-legacy";
import OpravneniApi from "../api/gen/cgo/OpravneniApi";
import * as localStorageUtils from "../utils/localStorageUtils";

export const LOGGED_IN_USER_AREA = "loggedInUserDetail";

/**
 * Načtení detailu přihlášeného uživatele.
 *
 * @returns {function(*): *}
 */
export const fetchLoggedInUserIfNeeded = () => {
    return (dispatch) => {
        return dispatch(detail.DetailActions.fetchIfNeeded(LOGGED_IN_USER_AREA, "", () => {
            return OpravneniApi.getUzivatel().then(data => {
                // přepsání role pro snadnější testování
                // @ts-ignore
                if (__DEV__) {
                    const role = localStorageUtils.load(data.id, "DEV_ROLE");
                    data.role = role || data.role;
                }
                return data;
            });
        }));
    }
};

/**
 * Zneplatnění detailu přihlášeného uživatele.
 *
 * @returns {function(*)}
 */
export const invalidateLoggedInUser = () => {
    return (dispatch) => {
        dispatch(detail.DetailActions.invalidate(LOGGED_IN_USER_AREA, ""));
    }
};
